import Modal from '@/components/modules/Modal';
import Asset from '@/components/views/Asset';
import type { AssetDetailModalProps } from '@/presentation/context/modal/ModalContext';
import { useRef } from 'react';

const AssetDetailModal = (props: AssetDetailModalProps) => {
  const rootRef = useRef(null);
  return (
    <Modal size="5xl" clickOffToClose={false} offset="">
      <div className="py-10 px-6" ref={rootRef}>
        <Asset {...props} root={rootRef} />
      </div>
    </Modal>
  );
};

export default AssetDetailModal;
